export function getImageCarrouselConfigurationOption(key) {
  const options = {
    'alt-text-max-length': 400,
    'button-text-max-length': 270, // max character limit for text is 300, but max character limit for postback data is 300 and postback data = 'alcQR;alc:db_name:ID:ID:ID;' + text 
    'button-title-max-length': 12,
    'max-elements':10,
  };
  if (options[key] != undefined) {
    return options[key];
  }
  return null;
}
